<div class="w-full lg:max-w-7xl p-8 mx-8 my-4">
    <span class="prose prose-sm !max-w-100">
        <ng-container>
            <div class="flex items-center justify-end">
                <button (click)="close()" mat-icon-button [matTooltip]="'Loka'">
                    <mat-icon class="text-secondary" [svgIcon]="'heroicons_outline:x'"></mat-icon>
                </button>
            </div>
            <h2 class="mt-[0px]">Aðgreining úrskurðar #{{ data.ruling.rulingNumber }} ({{
                data.ruling.paymentTransactionTypeAcronym
                }})
            </h2>
        </ng-container>
    </span>
    <mat-divider class="my-4"></mat-divider>

    <ng-container *ngIf="isLoading">
        <div class="grid sm:grid-cols-4 gap-6 w-full mt-[220px]">
            <div class="col-span-4">
                <app-loader-inline class="float-left"></app-loader-inline>
            </div>
        </div>
    </ng-container>

    <div *ngIf="!isLoading" class="p-6" mat-dialog-content>
        <div *ngIf="divisionOfRulingDetailsRes != null && !isLoading" class="scrollable-content">
            <div *ngIf="divisionOfRulingDetailsRes.divisionOfRulingsRes?.length > 0">
                <div class="prose prose-sm !max-w-100 mt-15">
                    <h3 class="mb-[0px]">Sundurliðun úrskurðar </h3>
                </div>
                <ng-container>
                    <div>
                        <div class="flex flex-wrap -m-2 mt-5 justify-center">
                            <table mat-table matSort #sortContributionsParent="matSort" [dataSource]="dataSourcePension"
                                class="w-full">
                                <ng-container matColumnDef="fund">
                                    <th mat-header-cell *matHeaderCellDef>Sjóður</th>
                                    <td mat-cell *matCellDef="let element"> {{ element.fund }} </td>
                                </ng-container>
                                <ng-container matColumnDef="rulingNumber">
                                    <th mat-header-cell *matHeaderCellDef>Númer úrskurðar</th>
                                    <td mat-cell *matCellDef="let element"> {{element.rulingNumber}} </td>
                                </ng-container>
                                <ng-container matColumnDef="fundPartnerSSN">
                                    <th mat-header-cell *matHeaderCellDef>Kennitala</th>
                                    <td mat-cell *matCellDef="let element"> {{element.fundPartnerSSN}} </td>
                                </ng-container>
                                <ng-container matColumnDef="benefitsTransactionType">
                                    <th mat-header-cell *matHeaderCellDef class="with-border">Teg Rétt.hr</th>
                                    <td mat-cell *matCellDef="let element" class="with-border">
                                        {{element.benefitsTransactionType}} </td>
                                </ng-container>
                                <div *ngIf="isPensionType()">
                                    <ng-container matColumnDef="benefitPension">
                                        <th mat-header-cell *matHeaderCellDef>Eftirlaun AT</th>
                                        <td mat-cell *matCellDef="let element"> {{
                                            localeService.localizeNumber(element.benefitPension) }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="benefitPension2">
                                        <th mat-header-cell *matHeaderCellDef>Eftirlaun JA</th>
                                        <td mat-cell *matCellDef="let element"> {{
                                            localeService.localizeNumber(element.benefitPension2) }} </td>
                                    </ng-container>
                                </div>
                                <div *ngIf="isSpouseType()">
                                    <ng-container matColumnDef="benefitSpouse">
                                        <th mat-header-cell *matHeaderCellDef>Makalífeyrir AT</th>
                                        <td mat-cell *matCellDef="let element"> {{
                                            localeService.localizeNumber(element.benefitSpouse) }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="benefitSpouse2">
                                        <th mat-header-cell *matHeaderCellDef>Makalífeyrir JA</th>
                                        <td mat-cell *matCellDef="let element"> {{
                                            localeService.localizeNumber(element.benefitSpouse2) }} </td>
                                    </ng-container>
                                </div>
                                <div
                                    *ngIf="data.ruling.isDisabilityType === 'J' || (data.ruling.isChildrenType === 'J' && data.ruling.paymentTransactionTypeAcronym.includes('O'))">
                                    <ng-container matColumnDef="benefitDisablity">
                                        <th mat-header-cell *matHeaderCellDef>Örorkulífeyrir AT</th>
                                        <td mat-cell *matCellDef="let element"> {{
                                            localeService.localizeNumber(element.benefitDisablity) }} </td>
                                    </ng-container>
                                    <ng-container matColumnDef="benefitDisablity2">
                                        <th mat-header-cell *matHeaderCellDef>Örorkulífeyrir JA</th>
                                        <td mat-cell *matCellDef="let element"> {{
                                            localeService.localizeNumber(element.benefitDisablity2) }} </td>
                                    </ng-container>
                                </div>
                                <ng-container matColumnDef="postponementAT">
                                    <th mat-header-cell *matHeaderCellDef class="with-border">Frestun/Flýting AT</th>
                                    <td mat-cell *matCellDef="let element" class="with-border"> {{
                                        localeService.localizeNumber(element.postponementAT) }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="postponementJA">
                                    <th mat-header-cell *matHeaderCellDef class="with-border">Frestun/Flýting JA</th>
                                    <td mat-cell *matCellDef="let element" class="with-border"> {{
                                        localeService.localizeNumber(element.postponementJA) }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="benefitsFuture">
                                    <th mat-header-cell *matHeaderCellDef>Framreikningur</th>
                                    <td mat-cell *matCellDef="let element"> {{
                                        localeService.localizeNumber(element.benefitsFuture) }} </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="pensionTableColumns"></tr>
                                <tr class="mat-row" mat-row *matRowDef="let logrow; columns: pensionTableColumns">
                                </tr>
                            </table>
                        </div>
                    </div>
                </ng-container>

                <div class="prose prose-sm !max-w-100 mt-15">
                    <h3 class="mb-[0px]">Aldurstengd ávinnsla </h3>
                </div>
                <ng-container>
                    <div>
                        <div class="flex flex-wrap -m-2 mt-5 justify-between">
                            <table mat-table matSort #sortContributionsParent="matSort"
                                [dataSource]="dataSourceAgeRelatedAcquisition" class="w-90">
                                <ng-container matColumnDef="benefitsTransactionType">
                                    <th mat-header-cell *matHeaderCellDef>Teg Rétt.hr</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.benefitsTransactionType }} </td>
                                </ng-container>
                                <ng-container matColumnDef="ageRelatedAcquisitionTotalAmount">
                                    <th mat-header-cell *matHeaderCellDef>Aldurstengd upphæð</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ localeService.localizeNumber(element.ageRelatedAcquisitionTotalAmount) }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="ageRelatedAcquisitionRatio">
                                    <th mat-header-cell *matHeaderCellDef>Hlutfall</th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ localeService.localizeNumber(element.ageRelatedAcquisitionRatio,
                                        'decimal', { minimumFractionDigits: 3, maximumFractionDigits: 3 } ) }} %</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="ageRelatedAcquisitionTableColumns"></tr>
                                <tr class="mat-row" mat-row
                                    *matRowDef="let logrow; columns: ageRelatedAcquisitionTableColumns">
                                </tr>
                            </table>
                        </div>
                    </div>
                </ng-container>

                <div class="prose prose-sm !max-w-100 mt-15">
                    <h3 class="mb-[0px]">Jöfn ávinnsla </h3>
                </div>
                <ng-container>
                    <div>
                        <div class="flex flex-wrap -m-2 mt-5 justify-center">
                            <table mat-table matSort #sortContributionsParent="matSort"
                                [dataSource]="dataSourceEqualAcquisition" class="w-full">
                                <ng-container matColumnDef="benefitsTransactionType">
                                    <th mat-header-cell *matHeaderCellDef>Teg Rétt.hr</th>
                                    <td mat-cell *matCellDef="let element"> {{ element.benefitsTransactionType }} </td>
                                </ng-container>
                                <ng-container matColumnDef="ageRelatedAcquisitionTotal">
                                    <th mat-header-cell *matHeaderCellDef>Aldurstend ávinnsla</th>
                                    <td mat-cell *matCellDef="let element"> {{
                                        localeService.localizeNumber(element.ageRelatedAcquisitionTotal) }} </td>
                                </ng-container>
                                <ng-container matColumnDef="equalAcquisitionTotal">
                                    <th mat-header-cell *matHeaderCellDef>Jöfn ávinnsla</th>
                                    <td mat-cell *matCellDef="let element"> {{
                                        localeService.localizeNumber(element.equalAcquisitionTotal) }} </td>
                                </ng-container>
                                <ng-container matColumnDef="leadningPensionAcquisitionType">
                                    <th mat-header-cell *matHeaderCellDef>Ríkjandi leið</th>
                                    <td mat-cell *matCellDef="let element"> {{ element.leadningPensionAcquisitionType }}
                                    </td>
                                </ng-container>
                                <ng-container matColumnDef="finalResult">
                                    <th mat-header-cell *matHeaderCellDef>Samtals</th>
                                    <ng-container *matCellDef="let element">
                                        <td mat-cell *ngIf="element.showJ" [attr.rowspan]="element.rowspan || 1">
                                            {{ localeService.localizeNumber(element.finalResult) }}
                                        </td>
                                    </ng-container>
                                </ng-container>
                                <ng-container matColumnDef="ratio">
                                    <th mat-header-cell *matHeaderCellDef>Hlutfall</th>
                                    <td mat-cell *matCellDef="let element"> {{
                                        localeService.localizeNumber(element.ratio,
                                        'decimal', { minimumFractionDigits: 3, maximumFractionDigits: 3 } ) }} %</td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="equalAcquisitionTableColumn"></tr>
                                <tr class="mat-row" mat-row
                                    *matRowDef="let logrow; columns: equalAcquisitionTableColumn">
                                </tr>
                            </table>
                        </div>
                    </div>
                </ng-container>
            </div>
            <div *ngIf="divisionOfRulingDetailsRes.summary != null">
                <div class="prose prose-sm !max-w-100 mt-15">
                    <h2 class="mb-[0px]">Niðurstöður
                        <span *ngIf="!divisionOfRulingConfirmed">#{{
                            divisionOfRulingDetailsRes.divisionOfRulingsRes[0].rulingNumber }}
                        </span>
                        <span *ngIf="divisionOfRulingConfirmed">#{{ data.ruling.rulingNumber }}</span>
                    </h2>
                    <div *ngIf="divisionOfRulingConfirmed" class="text-md text-hint sm:col-span-4 mb-[5px]">
                        <div>Síðast breytt: {{formatDate(
                            divisionOfRulingDetailsRes.summary.dateConfirmed) }}
                        </div>
                        <div *ngIf="divisionOfRulingDetailsRes.summary.reasonForChange !== ''">
                            Athugasemd: {{ divisionOfRulingDetailsRes.summary.reasonForChange }}
                        </div>
                    </div>
                    <mat-divider class="my-4 w-full"></mat-divider>
                </div>
                <ng-container>
                    <form [formGroup]="form">
                        <span class="font-medium">Teg Rétt.hr </span>
                        <div class="grid sm:grid-cols-1 gap-2 w-full mb-6">
                            <div class="grid grid-cols-4 w-50 gap-4 margin-top margin-bottom-10 mt-3 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">A</mat-label>
                                    <input matInput formControlName="aRatio">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="grid grid-cols-4 w-50 gap-4 margin-top margin-bottom-10 mt-3 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">J</mat-label>
                                    <input matInput formControlName="jRatio">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="grid grid-cols-4 w-50 gap-4 margin-top margin-bottom-10 mt-3 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">L</mat-label>
                                    <input matInput formControlName="lRatio">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="grid grid-cols-4 w-50 gap-4 margin-top margin-bottom-10 mt-3 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">S</mat-label>
                                    <input matInput formControlName="sRatio">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                        </div>
                        <span class="mt-6 font-medium">Sjóður</span>
                        <div class="grid sm:grid-cols-4 gap-6 w-full">
                            <div class="grid grid-cols-1 w-50 gap-4 margin-top margin-bottom-10 mt-5 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">AT</mat-label>
                                    <input matInput formControlName="fundAgeRelated">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class="grid grid-cols-1 w-50 gap-4 margin-top margin-bottom-10 mt-5 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">JA</mat-label>
                                    <input matInput formControlName="fundEqual">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                            <div class=" grid grid-cols-1 w-50 gap-4 margin-top margin-bottom-10 mt-5 w-full">
                                <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                    <mat-label class="font-medium">Samtals</mat-label>
                                    <input matInput readonly formControlName="total">
                                    <span matSuffix>%</span>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class=" grid grid-cols-1 w-full gap-4 margin-top margin-bottom-10 mt-5">
                            <mat-form-field class="fuse-mat-no-subscript basis-full sm:basis-80">
                                <mat-label class="font-medium">Athugasemd</mat-label>
                                <textarea matInput formControlName="comment"></textarea>
                            </mat-form-field>
                        </div>
                        <div class="flex items-center justify-end mt-[20px]">
                            <button mat-stroked-button type="button" (click)="close()" [disabled]="!formEnabled">
                                {{'label_cancel' | translate}} </button>
                            <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'"
                                [disabled]="!canSave()">
                                <span>
                                    <ng-container *ngIf="!divisionOfRulingConfirmed"> Staðfesta </ng-container>
                                    <ng-container *ngIf="divisionOfRulingConfirmed"> Vista </ng-container>
                                </span>
                                <mat-progress-spinner *ngIf="!formEnabled" [diameter]="24" [mode]="'indeterminate'">
                                </mat-progress-spinner>
                            </button>
                        </div>
                    </form>
                </ng-container>

                <div *ngIf="data.ruling.isChildrenType === 'N'">
                    <div *ngIf="data.ruling.isCSpouseType === 'J'">

                    </div>
                    <div class="prose prose-sm !max-w-100 mt-15">
                        <h2 *ngIf="data.ruling.isSpouseType === 'N'" class="mb-[0px]">Gildandi barnalífeyrisúrskurðir
                        </h2>
                        <h2 *ngIf="data.ruling.isSpouseType === 'J'" class="mb-[0px]">Tengdir úrskurðir </h2>
                        <mat-divider class="my-4 w-full"></mat-divider>
                    </div>
                    <ng-container>
                        <div *ngIf="relatedRulings !== ''">{{ relatedRulings }}</div>
                        <div *ngIf="relatedRulings === ''">Engir tengdir úrskurðir.</div>
                    </ng-container>
                    <div class="prose prose-sm !max-w-100 mt-15">
                        <h2 *ngIf="data.ruling.isSpouseType === 'N'" class="mb-[0px]">Eldri barnalífeyrisúrskurðir </h2>
                        <h2 *ngIf="data.ruling.isSpouseType === 'J'" class="mb-[0px]">Eldri úrskurðir </h2>
                        <mat-divider class="my-4 w-full"></mat-divider>
                    </div>
                    <ng-container>
                        <div *ngIf="invalidRelatedRulings !== ''">{{ invalidRelatedRulings }}</div>
                        <div *ngIf="invalidRelatedRulings === ''">Engir tengdir úrskurðir.</div>
                    </ng-container>
                </div>

                <div *ngIf="data.ruling.isChildrenType === 'J'">
                    <div class="prose prose-sm !max-w-100 mt-15">
                        <h2 class="mb-[0px]">Tengdur aðalúrskurður </h2>
                        <mat-divider class="my-4 w-full"></mat-divider>
                    </div>
                    <ng-container>
                        <div *ngIf="relatedParentRuling !== ''">{{ relatedParentRuling }}</div>
                        <div *ngIf="relatedParentRuling === ''">Enginn tengdur aðalúrskurður.</div>
                    </ng-container>

                    <div class="prose prose-sm !max-w-100 mt-15">
                        <h2 class="mb-[0px]">Eldri aðalúrskurður </h2>
                        <mat-divider class="my-4 w-full"></mat-divider>
                    </div>
                    <ng-container>
                        <div *ngIf="invalidrelatedParentRuling !== ''">{{ invalidrelatedParentRuling }}</div>
                        <div *ngIf="invalidrelatedParentRuling === ''">Enginn eldri aðalúrskurður.</div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div *ngIf="divisionOfRulingDetailsRes.divisionOfRulingsRes == null && divisionOfRulingDetailsRes.summary == null || divisionOfRulingDetailsRes?.divisionOfRulingsRes?.length === 0"
            class="flex flex-col flex-auto items-center justify-center p-6 sm:p-10">
            <div
                class="mt-12 sm:mt-24 text-4xl md:text-7xl font-extrabold tracking-tight leading-tight md:leading-none text-center">
                Engin skráning fannst</div>
            <div class="mt-2 text-lg md:text-xl font-medium tracking-tight text-center text-secondary">Engar upplýsingar
                fundust fyrir valinn úrskurð</div>
        </div>
    </div>

</div>